import { cloneDeep } from "lodash";
import { addDonationTeamNameToNotification, updateDonationNotificationStatus } from "./donationNotifications"; // prettier-ignore
import { sendDonationNotificationEmail, sendDonorThankYouEmail, sendLeaderboardRankDecrease, sendLeaderboardRankIncrease } from "./email"; // prettier-ignore
import { formatPlacementDecrease, formatPlacementIncrease } from "../utils/formatting"; // prettier-ignore
import { getRankings, getTeamLeadEmail, getTotalDonations } from "../utils/donations"; // prettier-ignore
import axios from "../axios";

export const fetchDonationsStarted = () => {
  return {
    type: "GET_DONATIONS_STARTED",
  };
};

export const fetchDonationsSuccess = (post) => {
  return {
    type: "GET_DONATIONS_SUCCESS",
    data: post,
  };
};

export const fetchDonationsFailure = (error) => {
  console.error("Unable to get donations data");
  return {
    type: "GET_DONATIONS_FAILURE",
    data: error,
  };
};

export const fetchDonations = () => {
  return (dispatch) => {
    dispatch(fetchDonationsStarted());
    return axios
      .get("/donations")
      .then((response) => {
        dispatch(fetchDonationsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchDonationsFailure(error));
      });
  };
};

export const addDonationsStarted = (data) => {
  return {
    type: "ADD_DONATIONS_STARTED",
    data: data,
  };
};

export const addDonationsSuccess = (data) => {
  return {
    type: "ADD_DONATIONS_SUCCESS",
    data: data,
  };
};

export const addDonationsFailure = (error) => {
  console.log("Unable to add donations data");
  return {
    type: "ADD_DONATIONS_FAILURE",
    data: error,
  };
};

export const addDonations = (data) => {
  return (dispatch) => {
    dispatch(addDonationsStarted(data));
    return axios
      .post("/donations", data)
      .then((response) => {
        dispatch(addDonationsSuccess(response));
        dispatch(fetchDonations());
      })
      .catch((error) => {
        dispatch(addDonationsFailure(error));
      });
  };
};

export const deleteDonationsStarted = (data) => {
  return {
    type: "DELETE_DONATIONS_STARTED",
    data: data,
  };
};

export const deleteDonationsSuccess = (data) => {
  return {
    type: "DELETE_DONATIONS_SUCCESS",
    data: data,
  };
};

export const deleteDonationsFailure = (error) => {
  console.log("Unable to delete donations data");
  alert("Error, please try again.");
  return {
    type: "DELETE_DONATIONS_FAILURE",
    data: error,
  };
};

export const deleteDonations = (data) => {
  return (dispatch) => {
    dispatch(deleteDonationsStarted(data));
    return axios
      .delete("/donations/" + data.id)
      .then((response) => {
        dispatch(deleteDonationsSuccess(response));
        dispatch(fetchDonations());
      })
      .catch((error) => {
        dispatch(deleteDonationsFailure(error));
      });
  };
};

export const updateDonationsStarted = (data) => {
  return {
    type: "UPDATE_DONATIONS_STARTED",
    data: data,
  };
};

export const updateDonationsSuccess = (data) => {
  return {
    type: "UPDATE_DONATIONS_SUCCESS",
    data: data,
  };
};

export const updateDonationsFailure = (error) => {
  console.log("Unable to update donations data");
  return {
    type: "UPDATE_DONATIONS_FAILURE",
    data: error,
  };
};

export const updateDonations = (data) => {
  return (dispatch) => {
    dispatch(updateDonationsStarted(data));
    return axios
      .put("/donations/" + data.id, {
        first_name: data.first_name,
        last_name: data.last_name,
        email_address: data.email_address,
        donation_data: data.donation_data,
        original_amount: data.original_amount,
        donation_amount: data.donation_amount,
        processing_fee_amount: data.processing_fee_amount,
        payment_selection_method: data.payment_selection_method,
        selected_team: data.selected_team,
        selected_beneficiary: data.selected_beneficiary,
        comment: data.comment,
        account_number: data.account_number,
        input_address: data.input_address,
        input_city: data.input_city,
        input_state: data.input_state,
        input_zip: data.input_zip,
      })
      .then((response) => {
        dispatch(updateDonationsSuccess(response));
        dispatch(fetchDonations());
      })
      .catch((error) => {
        dispatch(updateDonationsFailure(error));
      });
  };
};

export function sendDonorThankYou(donation, teamDonations = []) {
  const totalDonations = getTotalDonations(donation, teamDonations);
  const emailObject = {
    email: donation.email_address,
    amount: donation.original_amount,
    teamName: donation.selected_team,
    totalDonations: totalDonations,
  };
  return sendDonorThankYouEmail(emailObject);
}

// prettier-ignore
export function sendDonationNotification(donation, teamDonations = [], teams = []) {
  const teamLeadEmail = getTeamLeadEmail(donation.selected_team, teams);
  const totalDonations = getTotalDonations(donation, teamDonations);
  const emailObject = {
    email: teamLeadEmail,
    amount: donation.original_amount,
    teamName: donation.selected_team,
    totalDonations: totalDonations,
    firstName: donation.first_name,
    lastName: donation.last_name,
  };
  return sendDonationNotificationEmail(emailObject);
}

// prettier-ignore
export function sendLeaderboardRankingChanges(donation, teamDonations = [], teams = []) {
  return (dispatch) => {
    const teamIndex = teamDonations.findIndex(team => team.selected_team === donation.selected_team)
    const newTotalAmount = getTotalDonations(donation, teamDonations);
    const newDonations = cloneDeep(teamDonations);
    if (teamIndex >= 0 && teamIndex < newDonations.length) {
      newDonations[teamIndex].original_amount = newTotalAmount;
    }

    const previousRankings = getRankings(teamDonations);
    const newRankings = getRankings(newDonations);
    newRankings.forEach((team) => {
      const previous = previousRankings.find(item => item.selected_team === team.selected_team);
      const oldRank = previous.rank;
      const newRank = team.rank;
      const diff = oldRank - newRank;

      const rankObject = {
        teamName: team.selected_team,
        email: getTeamLeadEmail(team.selected_team, teams),
        totalDonations: team.original_amount,
      };

      if (diff > 0) {
        if (newRank <= 10) {
          rankObject.placement = formatPlacementIncrease(newRank);
          dispatch(sendLeaderboardRankIncrease(rankObject));
        }
      } else if (diff < 0) {
        if (oldRank <= 10) {
          rankObject.placement = formatPlacementDecrease(newRank);
          dispatch(sendLeaderboardRankDecrease(rankObject));
        }
      }
    });
  };
}

// prettier-ignore
export const submitDonation = (donation, teamDonations = [], teamsData = []) => {
  return (dispatch) => {
    try {
      dispatch(addDonations(donation));
      dispatch(sendDonorThankYou(donation, teamDonations));
      dispatch(sendDonationNotification(donation, teamDonations, teamsData));
      dispatch(sendLeaderboardRankingChanges(donation, teamDonations, teamsData));
      dispatch(addDonationTeamNameToNotification(donation.selected_team));
      dispatch(updateDonationNotificationStatus("open"));
    } catch (error) {
      console.error(error);
    }
  };
};
